export interface LocalizedString {
  english: string | null;
  arabic: string | null;
}

export enum PaymentMethodType {
  CreditCard = 0,
  DebitCard = 1,
  BankTransfer = 2,
  DigitalWallet = 3,
  CashOnDelivery = 4,
  Other = 5
}

// Image interface
interface Image {
  path: string;
  url: string;
}

// Main Payment Method Entity
export interface PaymentMethodEntity {
  id: number;
  name: LocalizedString;
  image: Image;
  status: number; // 1 = active, 0 = inactive
  type: number;
}

// Update interface - simplified to match other services pattern
export interface PaymentMethodUpdate {
  paymentMethodId: number;
  fields: {
    name?: LocalizedString;
    image?: string | null;
    state?: number; // 0 = inactive, 1 = active
  };
}
